import { SET_PROPERTY, UPDATE_IMAGES, RESET_VEHICLE_INFORMATION } from 'store/actions/imagesBench';
import { setValueObjectByField } from 'helpers/object';
import { VEHICLE_INFORMATION_OBJECT } from 'store/enums';

export default {
  [SET_PROPERTY]: (state, { field, value }) => {
    setValueObjectByField(state, field, value);
  },
  [UPDATE_IMAGES]: (state, images) => {
    state.images = images;
  },
  [RESET_VEHICLE_INFORMATION]: state => {
    state.vehicleInformation = JSON.parse(JSON.stringify(VEHICLE_INFORMATION_OBJECT));
  }
};
